import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Row, TextButton } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './TimeActivityActions.module.scss';
export const GetTimeActivityActionsTID = (parentTestId)=>getTestIds(parentTestId);
export const TimeActivityActions = (param)=>{
    let { showAddAll, isRefreshing, onAddAll, onRefresh, bi, testId } = param;
    const { t } = useLocaleKeys('components.billClientModal.timeActivities');
    const { TimeActivityActionsTestIds } = useMemo(()=>GetTimeActivityActionsTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(Row, {
        className: styles.actions,
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            showAddAll ? /*#__PURE__*/ _jsx(TextButton, {
                bi: bi.addAll,
                onClick: onAddAll,
                weight: "normal",
                underline: "none",
                testId: TimeActivityActionsTestIds.AddAll(),
                children: t.addAll()
            }) : /*#__PURE__*/ _jsx(Box, {}),
            /*#__PURE__*/ _jsx(TextButton, {
                bi: bi.refresh,
                onClick: onRefresh,
                weight: "normal",
                disabled: isRefreshing,
                underline: "none",
                testId: TimeActivityActionsTestIds.Refresh(),
                children: t.refresh()
            })
        ]
    });
};
